// extracted by mini-css-extract-plugin
export default {"item":"Item_item__MrYbc","item__user":"Item_item__user__ckg+v","item__feedback":"Item_item__feedback__lTav5"};